import styled from "styled-components";

export const InfoLine = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const BranchNumberText = styled.span`
    font-size: 1rem;
`;
  
export const Separator = styled.span`
    margin: 0 4px;
    color: #c0c0c0; /* Cinza claro para o separador */
`;